// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__29QMu","alertIcon":"ConfirmModal_alertIcon__25T1x"};